

export const exportToCsv = ({ title, headers, rows }) => {

    const csvString = [headers.join(","),
        ...rows.map(row => row.join(','))]
        .join('\n');
    const blob = new Blob([csvString], { "type": "text/csv;charset=utf8;" });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `${title.replace(/ /g, "_")}.csv`;
    link.click();

}


// WEBPACK FOOTER //
// ./src/handler/CsvHandler.js